import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"
import _imports_0 from '../../../assets/img/icons/close.svg'


const _hoisted_1 = { class: "card border-0 shadow-none rounded-1 mb-30" }
const _hoisted_2 = { class: "card-body p-xl-40" }
const _hoisted_3 = { class: "table-responsive" }
const _hoisted_4 = { class: "table text-nowrap align-middle mb-0" }
const _hoisted_5 = { class: "shadow-none lh-1 fs-14 fw-normal text-paragraph ps-0" }
const _hoisted_6 = { class: "shadow-none lh-1 fs-14 fw-normal text-paragraph" }
const _hoisted_7 = { class: "shadow-none lh-1 fs-14 fw-normal text-paragraph" }
const _hoisted_8 = { class: "badge badge-success fw-semibold fs-14" }
const _hoisted_9 = { class: "shadow-none lh-1 fs-14 fw-normal text-paragraph" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_QuantityCounter = _resolveComponent("QuantityCounter")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[3] || (_cache[3] = _createElementVNode("h6", { class: "fs-18 mb-40 text-title" }, "Selected Products For Adjustment", -1)),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("table", _hoisted_4, [
          _cache[2] || (_cache[2] = _createElementVNode("thead", null, [
            _createElementVNode("tr", null, [
              _createElementVNode("th", {
                scope: "col",
                class: "text-title fw-normal fs-14 pt-0 ps-0 ls-1"
              }, " PRODUCT "),
              _createElementVNode("th", {
                scope: "col",
                class: "text-title fw-normal fs-14 pt-0 ls-1"
              }, " PRODUCT CODE "),
              _createElementVNode("th", {
                scope: "col",
                class: "text-title fw-normal fs-14 pt-0 ls-1"
              }, " AVAILABLE STOCK "),
              _createElementVNode("th", {
                scope: "col",
                class: "text-title fw-normal fs-14 pt-0 ls-1"
              }, " QUANTITY "),
              _createElementVNode("th", {
                scope: "col",
                class: "text-title fw-normal fs-14 pt-0 ls-1"
              }, " TYPE "),
              _createElementVNode("th", {
                scope: "col",
                class: "text-title fw-normal fs-14 pt-0 ls-1 text-end pe-0"
              }, " DELETE ")
            ])
          ], -1)),
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.products, (product) => {
              return (_openBlock(), _createElementBlock("tr", {
                key: product.id
              }, [
                _createElementVNode("td", _hoisted_5, _toDisplayString(product.product), 1),
                _createElementVNode("td", _hoisted_6, _toDisplayString(product.code), 1),
                _createElementVNode("td", _hoisted_7, [
                  _createElementVNode("span", _hoisted_8, _toDisplayString(product.stock), 1)
                ]),
                _createElementVNode("td", _hoisted_9, [
                  _createVNode(_component_QuantityCounter)
                ]),
                _cache[0] || (_cache[0] = _createElementVNode("td", { class: "shadow-none lh-1" }, [
                  _createElementVNode("select", { class: "select-cat fs-14 fw-medium border-0" }, [
                    _createElementVNode("option", { value: "0" }, "Addition"),
                    _createElementVNode("option", { value: "0" }, "Deduction")
                  ])
                ], -1)),
                _cache[1] || (_cache[1] = _createElementVNode("td", { class: "shadow-none lh-1 text-end pe-0" }, [
                  _createElementVNode("div", { class: "button-group style-two ms-auto d-flex flex-wrap align-items-center" }, [
                    _createElementVNode("a", {
                      class: "delete-btn",
                      "data-bs-toggle": "offcanvas",
                      href: "#deletePopup",
                      role: "button",
                      "aria-controls": "deletePopup"
                    }, [
                      _createElementVNode("img", {
                        src: _imports_0,
                        alt: "Image"
                      })
                    ])
                  ])
                ], -1))
              ]))
            }), 128))
          ])
        ])
      ])
    ])
  ]))
}